import { inject, Injectable } from '@angular/core';
import { Translation, TranslocoLoader } from '@jsverse/transloco';
import { HttpClient } from '@angular/common/http';
import { of } from 'rxjs';
import ar from '../i18n/ar.json';
import en from '../i18n/en.json';
import da from '../i18n/da.json';
import fr from '../i18n/fr.json';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  private readonly http = inject(HttpClient);

  private readonly translationMap: Record<string, Translation> = {
    ar,
    en,
    da,
    fr,
  };

  getTranslation(lang: string) {
    return of(this.translationMap[lang]);
  }
}
